import { BaseGridRenderer, GridRenderOptions } from './base-grid-renderer';
import { ColumnJsonData } from '../../models/element-types';
import { DomUtils } from '../../utils/dom-utils';

export interface ColumnRenderOptions extends GridRenderOptions {
    size?: number;
}

export class ColumnRenderer extends BaseGridRenderer<ColumnJsonData> {
    protected get defaultData(): ColumnJsonData {
        return {
            id: '',
            type: 'column',
            size: 12
        };
    }

    public override createNew(options?: ColumnRenderOptions): HTMLElement {
        const data = { ...this.defaultData };
        data.id = DomUtils.generateUniqueElementId(options?.idsBlackList ?? []);
        if (options?.size !== undefined) {
            data.size = options.size;
        }
        return this.render(data, options);
    }

    protected renderElement(columnJsonData: ColumnJsonData, options?: GridRenderOptions): HTMLElement {
        const colSize = this.getEnsuredColSize(columnJsonData.size);

        const element = document.createElement('div');
        element.id = columnJsonData.id;
        element.dataset['colSize'] = `${colSize}`;
        element.dataset['meshCol'] = '';
        element.classList.add('col', `col-${colSize}`);
        element.classList.toggle('empty', options?.empty ?? true);

        return element;
    }

    private getEnsuredColSize(size: number): number {
        return Math.min(size, 12);
    }
}
